module.exports = __webpack_public_path__ + "img/抖音扫码305-305.9e7af0b4.png";